import { axios } from "../../helper/axios";
import { AmenitiesTableconstant } from "./AmenitiesTableConstant";

const AmenitiesTableApi = {};

AmenitiesTableApi.getAmenitiesTable = () => {
  return axios.get(AmenitiesTableconstant.AMENITIES_TABLE_API);
};

// post api

AmenitiesTableApi.postAmenitiesApi = (payload) => {

  return axios.post(AmenitiesTableconstant.POST_AMENITIES_API, {
    name: payload.amenitiesname,
  });
};

AmenitiesTableApi.UpdateAmenitiesApi = ({ payload }) => {
  return axios.put(AmenitiesTableconstant.UPDATE_AMENITIES_API, payload);
};

AmenitiesTableApi.AmenitiesEnableDisableApi = ({ id, status }) => {
  return axios.put(AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_API, {
    id: id,
    status: status,
  });
};

export { AmenitiesTableApi };
